<template>
    <div
        @click="onclick"
        data-component="kpl"
    >
        <slot></slot>
    </div>
</template>

<script type="text/ecmascript-6">
import { openByKpl } from '@/util/kpl';
import { PostSever } from '@/util/sqRequestService';

export default {
    name: 'KPL',
    props: {
        url: {
            type: String,
            default: ''
        },
        sku: {
            type: String,
            default: ''
        },
        eventId: {
            type: String,
            default: ''
        },
        eventParam: {
            type: String,
            default: ''
        },
        channel: {
            type: String,
            default: ''
        }
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {
        onclick() {
            let open = openByKpl;
            if (this.$openByKpl) {
                open = this.$openByKpl;
            }

            var me = this;
            if (me.sku && +me.sku > 0 && !$.device.jdapp) {
                PostSever('//sq.jr.jd.com/cfContent/getCpsLink', {
                    skuIds: me.sku,
                    positionId: '1816590445',
                    webId: '1277645018'
                }).then(
                    rs => {
                        open({
                            url: rs.value[0].shorUrl,
                            sku: me.sku,
                            eventId: me.eventId,
                            eventParam: me.eventParam,
                            channel: me.channel
                        });
                        this.$emit('upData');
                    },
                    () => {
                        open({
                            url: me.url,
                            sku: me.sku,
                            eventId: me.eventId,
                            eventParam: me.eventParam,
                            channel: me.channel
                        });
                        this.$emit('upData');
                    }
                );
            } else {
                open({
                    url: me.url,
                    sku: me.sku,
                    eventId: me.eventId,
                    eventParam: me.eventParam,
                    channel: me.channel
                });
                this.$emit('upData');
            }
        }
    },
    destroyed() {
        this.$refs = null;
        this._self = null;
    }
};
</script>
